module.exports = __webpack_public_path__ + "static/media/folding-hands.a4b6f5fa.gif";